import { IconProps } from "@/components/Icons/index";

export const StakingLogo: React.FC<IconProps> = (props) => {
  return <img src="/assets/images/staking.png" alt="iocoin" {...props} />;
};
